module.exports = __webpack_public_path__ + "public/images/netw-soon-main.0f3670f16d2bf37ca52c3376a23b836a.png";